import axios from "axios";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { Group } from "../../utils/logger";
import {
  CREDIT_TRANSFER_REPORT_LOADING,
  SET_CREDIT_TRANSFER_TYPES,
  SET_CREDIT_TRANSFER_SUBTYPES,
  SET_CREDIT_TRANSFER_STATS,
  CREDIT_TRANSFER_REPORT_DOWNLOADED,
  RESET_CREDIT_TRANSFER_REPORTS,
  ADD_CREDIT_TRANSFER_REPORT_ERROR,
  USER_TOKEN_NAME,
} from "../constants";

import { isLocal } from "../../utils/env";

const Logger = new Group("Credit Transfer Actions", { disable: true });

export const CREDIT_TRANSFER_SESSION_TOKEN = "amrnCreditTransferOptions";

export const addError = (error, name) => (dispatch) => {
  dispatch({ type: ADD_CREDIT_TRANSFER_REPORT_ERROR, payload: error, name });
};

// ============================================================================
// Get Options ================================================================
// ============================================================================

export const getTypeOptions = (options) => (dispatch) => {
  Logger.emit(`Getting report typeOptions`);

  dispatch({ type: CREDIT_TRANSFER_REPORT_LOADING, payload: "types" });
  return axios
    .post(`reports/credit-transfer/types`, options)
    .then((res) => {
      const payload = get(res, "data.types");

      payload && dispatch({ type: SET_CREDIT_TRANSFER_TYPES, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting types", { error });
      toastr.error(
        "Error",
        "There was a problem getting credit transfer 'type' options. Please try again later"
      );
      dispatch(addError(error, "types"));
    });
};

export const getSubTypeOptions = (options) => (dispatch) => {
  Logger.emit(`Getting report credit transfer subTypeOptions`);

  dispatch({ type: CREDIT_TRANSFER_REPORT_LOADING, payload: "subTypes" });
  return axios
    .post(`reports/credit-transfer/sub-types`, options)
    .then((res) => {
      const payload = get(res, "data.sub_types");

      payload && dispatch({ type: SET_CREDIT_TRANSFER_SUBTYPES, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting sub-types", { error });
      toastr.error(
        "Error",
        "There was a problem getting credit transfer 'sub-type' options. Please try again later"
      );
      dispatch(addError(error, "subTypes"));
    });
};

// ============================================================================
// Get Data ===================================================================
// ============================================================================

export const getCreditTransferStats = (options) => (dispatch) => {
  Logger.emit(`Getting credit transfer stats with options`, options);

  dispatch({ type: CREDIT_TRANSFER_REPORT_LOADING, payload: "stats" });

  return axios
    .post(`reports/credit-transfer/stats`, options)
    .then((res) => {
      const payload = get(res, "data");
      dispatch({ type: SET_CREDIT_TRANSFER_STATS, payload });
    })
    .catch((error) => {
      Logger.emit("Error getting report", { error: error });
      dispatch(addError(error, "stats"));
    });
};

export const downloadreport = (options) => (dispatch) => {
  Logger.emit(`Getting credit transfer download stats with options`, options);

  dispatch({ type: CREDIT_TRANSFER_REPORT_LOADING, payload: "credittransfer_download" });

  const domain = isLocal()
    ? `http://localhost:8000/api/v1`
    : `${window.location.protocol === "https:" ? "https://" : "http://"}${
        window.location.hostname
      }/api/v1`;

  let token = localStorage.getItem(USER_TOKEN_NAME);
  let url = new URL(`${domain}/reports/credittransfer/reportdownload`);

  Object.keys(options).forEach((key) =>
    url.searchParams.append(
      key,
      typeof options[key] === "string" ? options[key] : JSON.stringify(options[key])
    )
  );

  fetch(url, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + token,
    }),
  })
    .then((response) => response.blob())
    .then((blob) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "credittransfer-report.csv";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox

      dispatch({ type: CREDIT_TRANSFER_REPORT_DOWNLOADED, payload: {} });

      a.click();
      a.remove(); //afterwards we remove the element again
    });
};

//reset landing reducer state
export const resetState = () => ({ type: RESET_CREDIT_TRANSFER_REPORTS });
